import { type IconProps } from './types'

export function CassiSquareIcon({ width = '24', height = '24' }: IconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 301 300"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect
        x="0.921875"
        width="300.01"
        height="300"
        rx="56.252"
        fill="url(#paint0_linear_3897_6351)"
      />
      <path
        d="M245.472 76.3024C250.16 63.3337 237.593 50.7664 224.624 55.4656L66.1227 112.789C53.1105 117.499 51.5369 135.253 63.5073 142.188L114.102 171.479L159.281 126.3C161.328 124.323 164.069 123.229 166.915 123.254C169.76 123.279 172.482 124.42 174.494 126.432C176.506 128.444 177.648 131.166 177.672 134.012C177.697 136.857 176.603 139.599 174.626 141.646L129.447 186.825L158.749 237.419C165.673 249.39 183.428 247.805 188.138 234.804L245.472 76.3024Z"
        fill="white"
      />
      <path
        d="M34.4648 211.854L76.3196 169.999"
        stroke="white"
        strokeWidth="18.7507"
        strokeLinecap="round"
      />
      <path
        d="M98.707 254.885L128.254 225.337"
        stroke="white"
        strokeWidth="18.7507"
        strokeLinecap="round"
      />
      <path
        d="M92.6992 207.51L111.623 188.586"
        stroke="white"
        strokeWidth="18.7507"
        strokeLinecap="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3897_6351"
          x1="-13.1162"
          y1="-3.58356e-06"
          x2="385.098"
          y2="453.334"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#6864FF" />
          <stop offset="1" stopColor="#3434AD" />
        </linearGradient>
      </defs>
    </svg>
  )
}
